<div
    class="bg-on-primary rounded-xl h-full"
    [class.edit-border]="isProjectEditModeActive()">
    @if (selectSynopticService.isLoading()) {
        <app-loading />
    } @else {
        @if (selectSynopticService.isSynopticDisplayed()) {
            <app-synoptic-graph />
        } @else if (!selectSynopticService.hasSynopticAvailable()) {
            <app-no-data-to-display
                [iconSize]="'5x'"
                [information]="'noSynopticFound'" />
        } @else {
            <app-select-synoptic-panel />
        }
    }
</div>
